import { createSlice } from '@reduxjs/toolkit';
import {
  BasicInfoPropsContent,
  BasicInfoProps,
  QuestionContentProps,
  OriginalFormProps,
} from '~/common/types';

import { createOriginalForm } from '~/apiTs';

const initBasicInfoPropsContent: BasicInfoPropsContent = {
  isActive: false,
  isRequired: false,
};

const initBasicInfoProps: BasicInfoProps = {
  age: initBasicInfoPropsContent,
  gender: initBasicInfoPropsContent,
  area: initBasicInfoPropsContent,
};

const initQuestionsContent: QuestionContentProps = {
  title: '',
  description: '',
  basicInfo: initBasicInfoProps,
};

const initialState: OriginalFormProps = {
  id: 0,
  name: '',
  questionsContent: initQuestionsContent,
};

const originalFormSlice = createSlice({
  name: 'originalForm',
  initialState,
  reducers: {
    initialize: () => initialState,

    updated: (state, action) => ({
      ...state,
      ...action.payload,
    }),
  },

  extraReducers: {
    // Update data when original form survey is created
    [createOriginalForm.fulfilled.type]: (state, action) => ({
      ...state,
      id: action.payload.result.id,
      name: '',
      questionsContent: initQuestionsContent,
    }),
  },
});

export default originalFormSlice.reducer;
